import { SERVICE_TYPES } from '@/constants/FullfilmentTypes';

import { ProductType } from '@/server/services/core/product/models';
import { ProductBatteryType } from '@/server/services/core/productBattery/models';
import { ActiveOfferContent } from '@/server/services/vendor/models';

export const mapBatteryProductToOffer = (product: ProductType & Partial<ProductBatteryType>): ActiveOfferContent => {
    return {
        offerId: 1,
        productUuid: product.uuid,
        productTitle: product.title,
        brandId: product.brand.id,
        brandName: product.brand.name,
        categoryId: product.category.id,
        productSlug: product.slug,
        guarantee: product.guarantee ?? 0,
        storeUuid: '940b0d53-84c6-470b-b7e0-0f32cb0745ba',
        storeName: 'ازکی‌سرویس',
        storeSlug: '',
        storeRating: 4.4,
        storeReviewCount: 0,
        price: product.price,
        sellingPrice: product.sellingPrice,
        discount: 0,
        discountPercentage: product.discountPercentage,
        availableQuantity: product.available ? 1 : 0,
        hasShipping: false,
        hasInstallCenter: false,
        hasInstallOnsite: true,
        hasPickupCenter: false,
        isBuyBoxWinner: true,
        buyBoxScore: 0,
        distanceKm: 0,
        fulfillmentProfiles: [
            {
                fulfillmentProfileId: SERVICE_TYPES.INSTALL_ONSITE.id,
                fulfillmentType: 'INSTALL_ONSITE',
                zoneType: '',
                zoneRadiusKm: 0,
                minBaseCost: 0,
                laborFee: 0,
                isFree: true,
                minOffsetDays: 0,
                isEligible: true
            }
        ]
    };
};
